type PlayType = iconProps & {
  id?: string
}

function MediaPause(props: PlayType) {
  const fill = props.fill || 'currentColor'
  const strokewidth = props.strokewidth || 2
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'Pause'
  // const id = props.id || ''

  return (
    <svg
      height={height}
      width={width}
      viewBox='0 0 48 48'
      xmlns='http://www.w3.org/2000/svg'
      className={props.className}
    >
      <title>{title}</title>
      <g
        // fill={fill}
        strokeLinecap='square'
        strokeLinejoin='miter'
        strokeMiterlimit='10'
      >
        <path
          d='M29 7V41H40V7H29Z'
          fill='currentColor'
          stroke={fill}
          strokeWidth={strokewidth}
        />
        <path
          d='M8 7V41H19V7H8Z'
          fill='currentColor'
          stroke={fill}
          strokeWidth={strokewidth}
        />
      </g>
    </svg>
  )
}

export default MediaPause
